
import BrandComponents from "../../Masters/Brand/BrandComponents";


function GroupTable() {
  let header = [
    { label: "Id", field: "id" },
    { label: "Group Name", field: "groupname" },
    { label: "Action", field: "action" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"Group"}
        apiField={"productGroup"}
        addButton={"+ ADD"}
        createRoute={"/groupCreate"}
        updateRoute={"/groupEdit"}
        viewRoute={"/groupView"}
      />
    </div>
  );
}

export default GroupTable;
